var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25293,
    y: 0.171875,
    width: 45.1627,
    height: 45.1627,
    rx: 22.5813,
    fill: "#EEEDFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2424_9241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 13.253V19.753C23 20.1508 23.158 20.5323 23.4393 20.8136C23.7206 21.0949 24.1022 21.253 24.5 21.253H31V31.253C31 31.7834 30.7893 32.2921 30.4142 32.6672C30.0391 33.0422 29.5304 33.253 29 33.253H21.868C21.953 33.003 22 32.731 22 32.444V28.254C22.7221 27.2911 23.0727 26.1001 22.9874 24.8995C22.9021 23.699 22.3866 22.5695 21.5355 21.7184C20.6845 20.8674 19.555 20.3519 18.3544 20.2665C17.1539 20.1812 15.9629 20.5318 15 21.254V15.252C15 14.7215 15.2107 14.2128 15.5858 13.8377C15.9609 13.4627 16.4696 13.252 17 13.252H23V13.253ZM18 22.253C18.6076 22.253 19.2008 22.4375 19.7012 22.782C20.2016 23.1265 20.5856 23.6149 20.8024 24.1825C21.0192 24.75 21.0586 25.3701 20.9153 25.9605C20.772 26.5509 20.4528 27.0839 20 27.489V32.444C20 32.5292 19.9782 32.6131 19.9367 32.6875C19.8951 32.762 19.8352 32.8246 19.7627 32.8694C19.6901 32.9142 19.6073 32.9397 19.5221 32.9434C19.437 32.9472 19.3522 32.9292 19.276 32.891L18 32.253L16.724 32.891C16.6478 32.9292 16.563 32.9472 16.4779 32.9434C16.3927 32.9397 16.3099 32.9142 16.2373 32.8694C16.1648 32.8246 16.1049 32.762 16.0633 32.6875C16.0218 32.6131 16 32.5292 16 32.444V27.489C15.5472 27.0839 15.228 26.5509 15.0847 25.9605C14.9414 25.3701 14.9808 24.75 15.1976 24.1825C15.4144 23.6149 15.7984 23.1265 16.2988 22.782C16.7992 22.4375 17.3924 22.253 18 22.253ZM25 13.296C25.3789 13.3763 25.7263 13.5649 26 13.839L30.414 18.253C30.688 18.5267 30.8766 18.8741 30.957 19.253H25V13.296Z",
    fill: "#000C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2424_9241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11.2529)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documentsIcon.58a986357464ced387636a93f449e4bf.svg";
export { ForwardRef as ReactComponent };